import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch, Redirect } from 'react-router-dom'
import Sidebar from '../Sidebar'
import Home from '../Home'
import BoardViewContainer from '../Board/BoardViewContainer'
import FolderContainer from '../Folder/FolderContainer'
import ShareModal from '../ShareModal'
import Settings from '../Settings'
import { routes } from 'variables'
import ExtraRoute from 'common/ExtraRoute'
import RootLoader from 'Root/RootLoader'
import Alerts from '../Alerts'
import { Container, ContentArea } from 'common/components/Content'
import { injectGlobal } from 'emotion'
import Activity from '../Activity'
import ErrorPage from '../ErrorPage'
import useShareAccept from 'app/hooks/useShareAccept'

injectGlobal({
  // the page must not scroll for the app, scroll is all inside divs
  // TODO use emotion 10 <Global>
  'html.app': {
    height: '100%',
    overflow: 'hidden',
    'body, #root': {
      height: '100%'
    }
  }
})

const App = ({ embedMode, mustAcceptTerms, hasError }) => {
  if (mustAcceptTerms) return <RootLoader step="Terms" />
  const state = useShareAccept()

  if (!state.loaded) return <RootLoader step="Access" />

  return (
    <>
      <Redirects />
      {!hasError && (
        <Container>
          <Switch>
            <Route path="/settings" component={Settings} />
            <Route
              render={() => (
                <>
                  {!embedMode && <Sidebar />}
                  <Activity />

                  {state.error ? (
                    <ContentArea>
                      <ErrorPage error={state.error} />
                    </ContentArea>
                  ) : (
                    <ContentArea>
                      <Route path="/" exact component={Home} />
                      <Route
                        path={routes.board}
                        component={BoardViewContainer}
                      />
                      <Route path={routes.folder} component={FolderContainer} />
                    </ContentArea>
                  )}

                  <ExtraRoute path="#share/:type/:id" component={ShareModal} />
                </>
              )}
            />
          </Switch>
        </Container>
      )}
      <Alerts />
    </>
  )
}

App.propTypes = {
  embedMode: PropTypes.bool
}

const getShare = search => {
  const match = search.match(/share=([^&]*)/)
  if (match) return '.s' + match[1]
  return ''
}

const Redirects = () => (
  <>
    <Route
      path="/b/:boardName([^-]+)-:boardId/:embed(embed)?/"
      exact
      render={({ match, location }) => (
        <Redirect
          to={`/${match.params.boardName}.b${match.params.boardId}${getShare(
            location.search
          )}${match.params.embed ? '.embed' : ''}`}
        />
      )}
    />
    <Route
      path="/b/:boardName([^-]+)-:boardId/:blockId/:embed(embed)?/"
      render={({ match, location }) => (
        <Redirect
          to={`/${match.params.boardName}.b${match.params.boardId}/${
            match.params.blockId
          }${getShare(location.search)}${match.params.embed ? '.embed' : ''}`}
        />
      )}
    />
    <Route
      path="/f/:folderName([^-]+)-:folderId/"
      render={({ match, location }) => (
        <Redirect
          to={`/${match.params.folderName}.f${match.params.folderId}${getShare(
            location.search
          )}`}
        />
      )}
    />
  </>
)

export default App
